import "./OurExpertise.module.css";
import Header from "@/reusable_sections/Header";
import OurExpertise from "./sections/OurExpertise";
import ThePerfectProtocol from "./sections/ThePerfectProtocol";
import Footer from "@/reusable_sections/Footer";
export default function OurExpertisePage() {
  return <div>
      <Header />
      <OurExpertise />
      <ThePerfectProtocol />
      <Footer />
    </div>;
}